<template>
  <div class="app-container">
    <el-form class="header-filter">
      <div class="filter-container">
        <div class="filter-form">
          <el-form-item>
            <el-input v-model="query.name" @keyup.enter.native="reGetList" placeholder="name" />
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="query.domainIds"
              multiple
              clearable
              placeholder="domains"
              filterable
              remote
              :loading="selectLoading"
              :remote-method="getDomains"
            >
              <el-option
                v-for="item in domains"
                :key="item.id"
                :label="item.content"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="query.taskIds"
              multiple
              clearable
              placeholder="tasks"
              filterable
              remote
              :loading="selectLoading"
              :remote-method="getTasks"
            >
              <el-option
                v-for="item in tasks"
                :key="item.id"
                :label="item.content"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="locale" @change="resetList">
              <el-option v-for="e in i18nConfig.locales" :key="e" :label="e" :value="e"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="query.status" @change="reGetList" clearable placeholder="上下架">
              <el-option label="上架" value="AVAILABLE"></el-option>
              <el-option label="下架" value="UNAVAILABLE"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="query.sortField"
              @change="reGetList"
              clearable
              placeholder="创建/更新时间"
            >
              <el-option label="create_time" value="create_time"></el-option>
              <el-option label="update_time" value="update_time"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="query.sort" @change="reGetList" clearable placeholder="升降序">
              <el-option label="desc" value="desc"></el-option>
              <el-option label="asc" value="asc"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="filter-btns">
          <el-button @click="reGetList" type="primary">查询</el-button>
          <el-button @click="openDialog">新增</el-button>
        </div>
      </div>
    </el-form>

    <div class="table-wrapper">
      <el-table ref="table" :data="list" v-loading="listLoading">
        <el-table-column align="center" prop="rank" width="120" label="rank"></el-table-column>
        <el-table-column align="center" prop="id" width="180" label="id"></el-table-column>
        <el-table-column
          align="center"
          prop="votesCount"
          width="140"
          label="投票数"
        ></el-table-column>
        <el-table-column align="center" label="logo" width="100">
          <template slot-scope="scope">
            <img :src="scope.row.logoUrl | filterImage" class="show-img" />
          </template>
        </el-table-column>
        <el-table-column align="center" label="name" prop="name" min-width="180" />
        <el-table-column align="center" label="预览图" min-width="180">
          <template slot-scope="scope">
            <div class="grid-box">
              <img
                v-for="e in scope.row.previewUrl"
                :key="e"
                :src="e | filterImage"
                class="show-img"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="createTime" width="200">
          <template slot-scope="scope">
            {{ +scope.row.createTime | filterTimeStamp }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="updateTime" width="200">
          <template slot-scope="scope">
            {{ +scope.row.updateTime | filterTimeStamp }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="上下架" width="100" fixed="right">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              @change="handleUpdate(scope.row)"
              active-value="AVAILABLE"
              inactive-value="UNAVAILABLE"
            />
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="260" fixed="right">
          <template slot-scope="scope">
            <el-button
              @click="postReUpdate(scope.row)"
              type="primary"
              size="mini"
              :loading="scope.row.loading"
              >更新</el-button
            >
            <el-button @click="openDialog(scope.row)" type="primary" size="mini">编辑</el-button>
            <el-button @click="handleDelete(scope.row)" size="mini" type="danger">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="query.current"
          :total="listTotal"
          :page-sizes="[10, 20, 30, 50]"
        />
      </div>
    </div>

    <el-dialog :title="currentRow.id ? '编辑' : '新增'" :visible.sync="dialogVisible" width="800px">
      <div
        class="flex-container"
        style="margin-bottom: 10px; justify-content: flex-end"
        v-if="!currentRow.id"
      >
        <el-radio v-model="addType" label="LINK">链接新增</el-radio>
        <el-radio v-model="addType" label="FORM">表单新增</el-radio>
        <el-radio v-model="addType" label="CONTENT">大文本新增</el-radio>
      </div>
      <el-form
        class="post-main-container post-dialog-container long"
        label-position="right"
        v-if="currentRow.id || addType === 'FORM'"
      >
        <el-form-item label="name：" required>
          <el-input v-model.trim="currentRow.name" />
          <p v-if="currentRow.toolifyName">toolifyName: {{ currentRow.toolifyName }}</p>
        </el-form-item>
        <el-form-item label="companyName：" class="long">
          <el-input v-model.trim="currentRow.companyName" />
        </el-form-item>
        <el-form-item label="slugName：">
          <el-input v-model.trim="currentRow.slugName" />
        </el-form-item>
        <el-form-item label="isFollowed：">
          <el-input type="number" v-model.number.trim="currentRow.isFollowed" />
        </el-form-item>
        <el-form-item label="logo：" required>
          <upload-image
            :originData="currentRow.logoUrl"
            @postImage="updateLogo"
            :limit="1"
            @deleteImageUrl="onDeleteLogo"
          />
        </el-form-item>
        <el-form-item label="预览图：">
          <upload-image
            :originData="currentRow.previewUrl"
            @postImage="updatePreviewUrl"
            @onDragEnd="onDragPreviewUrl"
            @deleteImageUrl="onDeletePreviewUrl"
          />
        </el-form-item>
        <el-form-item label="websiteUrl：" required class="long">
          <el-input v-model.trim="currentRow.websiteUrl" />
          <P v-if="currentRow.originUrl">originUrl: {{ currentRow.originUrl }}</P>
        </el-form-item>
        <el-form-item label="profile：" required>
          <el-input type="textarea" v-model="currentRow.profile" />
          <p v-if="currentRow.toolifyProfile">toolifyProfile: {{ currentRow.toolifyProfile }}</p>
        </el-form-item>
        <el-form-item label="briefProfile：" required class="long">
          <el-input type="textarea" v-model="currentRow.briefProfile" />
        </el-form-item>
        <el-form-item label="seoTitle：" required>
          <el-input v-model.trim="currentRow.seoTitle" />
        </el-form-item>
        <el-form-item label="seoDesc：" required>
          <el-input v-model.trim="currentRow.seoDesc" />
        </el-form-item>
        <el-form-item label="votesBase：">
          <el-input v-model.number.trim="currentRow.votesBase" />
        </el-form-item>
        <el-form-item label="similarwebViewsCount：" class="long">
          <el-input v-model.number.trim="currentRow.similarwebViewsCount" />
        </el-form-item>
        <el-form-item label="domains：">
          <el-select
            v-model="domainIds"
            multiple
            filterable
            remote
            :loading="selectLoading"
            :remote-method="getDomains"
          >
            <el-option
              v-for="item in domains"
              :key="item.id"
              :label="item.content"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="tasks：">
          <el-select
            v-model="taskIds"
            multiple
            filterable
            remote
            :loading="selectLoading"
            :remote-method="getTasks"
          >
            <el-option
              v-for="item in tasks"
              :key="item.id"
              :label="item.content"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="更新mode：">
          <el-radio v-model="currentRow.originData.mode" label="URL">链接</el-radio>
          <el-radio v-model="currentRow.originData.mode" label="TEXT">文本</el-radio>
        </el-form-item>
        <el-form-item label="更新链接：">
          <el-input v-model.trim="currentRow.originData.originUrl" />
        </el-form-item>
        <el-form-item label="更新文本：">
          <el-input type="textarea" v-model="currentRow.originData.originData" />
        </el-form-item>
        <el-form-item label="viewsCount：" v-if="currentRow.viewsCount">{{
          currentRow.viewsCount
        }}</el-form-item>
        <el-form-item label="votesCount：" v-if="currentRow.votesCount">{{
          currentRow.votesCount
        }}</el-form-item>
        <el-form-item class="long" label="websiteLinkCount：" v-if="currentRow.websiteLinkCount">{{
          currentRow.websiteLinkCount
        }}</el-form-item>
        <el-form-item class="long" label="votesBaseCustomerService：">
          <el-input v-model.number.trim="currentRow.votesBaseCustomerService" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseDesignAndCreativity：">
          <el-input v-model.number.trim="currentRow.votesBaseDesignAndCreativity" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseEducationAndTraining：">
          <el-input v-model.number.trim="currentRow.votesBaseEducationAndTraining" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseFinance：">
          <el-input v-model.number.trim="currentRow.votesBaseFinance" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseHumanResources：">
          <el-input v-model.number.trim="currentRow.votesBaseHumanResources" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseInformationTechnology：">
          <el-input v-model.number.trim="currentRow.votesBaseInformationTechnology" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseLegal：">
          <el-input v-model.number.trim="currentRow.votesBaseLegal" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseManagement：">
          <el-input v-model.number.trim="currentRow.votesBaseManagement" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseMarketing：">
          <el-input v-model.number.trim="currentRow.votesBaseMarketing" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseOperations：">
          <el-input v-model.number.trim="currentRow.votesBaseOperations" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseResearchAndDevelopment：">
          <el-input v-model.number.trim="currentRow.votesBaseResearchAndDevelopment" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseSales：">
          <el-input v-model.number.trim="currentRow.votesBaseSales" />
        </el-form-item>
      </el-form>
      <el-form
        class="post-main-container post-dialog-container long"
        label-position="right"
        v-else-if="addType === 'CONTENT'"
      >
        <el-form-item label="大文本：" required>
          <el-input type="textarea" v-model="bigText" />
        </el-form-item>
      </el-form>
      <el-form class="post-main-container post-dialog-container long" label-position="right" v-else>
        <el-form-item label="link：" required>
          <el-input v-model.trim="link" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
        <el-button type="primary" :loading="btnLoading" @click="postEdit">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getTools,
  updateTool,
  deleteTool,
  saveToolFromUrl,
  saveToolFromContent,
  reUpdateTool
} from '@/api/content'
import { getCategories } from '@/api/categories'
import { i18nConfig } from '@/utils'

const defaultRow = {
  name: '',
  companyName: '',
  slugName: '',
  logoUrl: '',
  previewUrl: [],
  websiteUrl: '',
  profile: '',
  seoTitle: '',
  seoDesc: '',
  votesBase: '0',
  votesBaseCustomerService: '0',
  votesBaseDesignAndCreativity: '0',
  votesBaseEducationAndTraining: '0',
  votesBaseFinance: '0',
  votesBaseHumanResources: '0',
  votesBaseInformationTechnology: '0',
  votesBaseLegal: '0',
  votesBaseManagement: '0',
  votesBaseMarketing: '0',
  votesBaseOperations: '0',
  votesBaseResearchAndDevelopment: '0',
  votesBaseSales: '0',
  originData: {
    mode: 'URL',
    originData: '',
    originUrl: ''
  },
  isFollowed: 0,
  status: 'UNAVAILABLE'
}

export default {
  data() {
    return {
      i18nConfig,
      locale: i18nConfig.defaultLocale,
      list: [],
      listTotal: null,
      listLoading: true,

      query: {
        limit: 10,
        current: 1,
        name: '',
        domainIds: [],
        taskIds: [],
        status: '',
        sortField: '',
        sort: ''
      },

      btnLoading: false,
      dialogVisible: false,
      currentRow: {},
      link: '',
      bigText: '',

      domains: [],
      tasks: [],
      domainIds: [],
      taskIds: [],
      selectLoading: false,

      addType: 'LINK'
    }
  },

  mounted() {
    this.resetList()
  },

  methods: {
    postReUpdate(data) {
      const { id, name } = data
      const { mode, originData, originUrl } = data.originData
      if (!mode || (mode === 'URL' && !originUrl) || (mode === 'TEXT' && !originData)) {
        this.$message.error('请选择更新模式并填写相关更新字段')
        return
      }

      this.$confirm(`是否更新工具 ${name}`, '提示', {}).then(() => {
        data.loading = true
        reUpdateTool(id, this.locale)
          .then(() => {
            this.getList()
          })
          .finally(() => {
            data.loading = false
          })
      })
    },

    getDomains(content) {
      this.selectLoading = true
      getCategories(
        {
          content,
          auditStatus: 'APPROVED',
          status: 'AVAILABLE',
          type: 'DOMAIN'
        },
        this.locale
      )
        .then((res) => {
          this.domains = res.result.rows.filter((e) => e.slugName !== 'all-domains')
        })
        .finally(() => {
          this.selectLoading = false
        })
    },

    handleDelete(row) {
      const { id, name } = row
      this.$confirm(`是否删除工具 ${name}`, '提示', {}).then(() => {
        deleteTool(id, this.locale).then(() => {
          this.getList()
        })
      })
    },

    getTasks(content) {
      this.selectLoading = true
      getCategories(
        {
          content,
          auditStatus: 'APPROVED',
          status: 'AVAILABLE',
          type: 'TASK'
        },
        this.locale
      )
        .then((res) => {
          this.tasks = res.result.rows.filter((e) => e.slugName !== 'all-tasks')
        })
        .finally(() => {
          this.selectLoading = false
        })
    },

    updateLogo(e) {
      this.currentRow.logoUrl = e
    },

    onDeleteLogo() {
      this.currentRow.logoUrl = ''
    },

    onDragPreviewUrl(e) {
      this.currentRow.previewUrl = e
    },

    onDeletePreviewUrl(index) {
      this.currentRow.previewUrl.splice(index, 1)
    },

    updatePreviewUrl(e) {
      this.currentRow.previewUrl.push(e)
    },

    checkFormFull() {
      if (this.addType === 'LINK' && !this.currentRow.id) {
        if (!this.link) {
          this.$message.error('请填写必填项')
          return false
        }
        return true
      }
      if (this.addType === 'CONTENT' && !this.currentRow.id) {
        if (!this.bigText) {
          this.$message.error('请填写必填项')
          return false
        }
        return true
      }
      const { name, logoUrl, websiteUrl, profile, seoTitle, seoDesc } = this.currentRow
      if ([name, logoUrl, websiteUrl, profile, seoTitle, seoDesc].includes('')) {
        this.$message.error('请填写必填项')
        return false
      }
      return true
    },

    postEdit() {
      if (!this.checkFormFull()) return
      if (this.addType === 'LINK' && !this.currentRow.id) {
        this.btnLoading = true
        saveToolFromUrl(this.link, this.locale)
          .then(() => {
            this.dialogVisible = false
            this.getList()
          })
          .finally(() => {
            this.btnLoading = false
          })
      } else if (this.addType === 'CONTENT' && !this.currentRow.id) {
        this.btnLoading = true
        saveToolFromContent(this.bigText, this.locale)
          .then(() => {
            this.dialogVisible = false
            this.getList()
          })
          .finally(() => {
            this.btnLoading = false
          })
      } else {
        const metaTagRelations = this.domainIds
          .concat(this.taskIds)
          .map((id) => ({ metaTagId: id }))
        const form = JSON.parse(JSON.stringify(this.currentRow))
        this.btnLoading = true
        form.metaTagRelations = metaTagRelations
        this.handleUpdate(form)
          .then(() => {
            this.dialogVisible = false
          })
          .finally(() => {
            this.btnLoading = false
          })
      }
    },

    handleUpdate(row) {
      return new Promise((resolve, reject) => {
        updateTool(row, this.locale)
          .then(() => {
            this.getList()
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },

    openDialog(row) {
      this.link = ''
      this.bigText = ''
      this.addType = 'LINK'
      if (row.id) {
        this.domainIds = row.domains.map((e) => e.id)
        this.taskIds = row.tasks.map((e) => e.id)
        this.currentRow = JSON.parse(JSON.stringify(row))
        this.domains = this.currentRow.domains
        this.tasks = this.currentRow.tasks
      } else {
        this.domainIds = []
        this.taskIds = []
        this.currentRow = JSON.parse(JSON.stringify(defaultRow))
      }
      this.dialogVisible = true
    },

    reGetList() {
      this.query.current = 1
      this.getList()
    },

    resetList() {
      this.query.domainIds = []
      this.query.taskIds = []
      this.reGetList()
      this.domains = []
      this.tasks = []
    },

    getList() {
      this.listLoading = true
      const form = JSON.parse(JSON.stringify(this.query))
      if (!form.sortField) {
        delete form.sortField
      }
      if (!form.sort) {
        delete form.sort
      }
      getTools(form, this.locale).then((res) => {
        this.list = res.result.rows.map((e) => ({
          ...e,
          originData: e.originData || {
            mode: 'URL',
            originData: '',
            originUrl: ''
          },
          loading: false
        }))
        this.listTotal = +res.result.total
        this.listLoading = false
      })
    },

    handleSizeChange(val) {
      this.query.limit = val
      this.reGetList()
    },

    handleCurrentChange(val) {
      this.query.current = val
      this.getList()
    }
  }
}
</script>

<style scoped>
.grid-box {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.show-img {
  width: 40px;
  height: 40px;
}
</style>
